import { render } from "./CrNavigationBottom.vue?vue&type=template&id=f6e6335e&scoped=true"
import script from "./CrNavigationBottom.vue?vue&type=script&lang=js"
export * from "./CrNavigationBottom.vue?vue&type=script&lang=js"

import "./CrNavigationBottom.vue?vue&type=style&index=0&id=f6e6335e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e6335e"]])

export default __exports__